module.exports = __webpack_public_path__ + "static/media/summer.621ff9dd.png";